import { styled } from '@innowise-group/mui-kit';

export const SalaryIconContainer = styled.div`
  display: flex;
  cursor: pointer;

  & svg {
    fill: ${({ theme }) => theme.palette.general.darkGrey[70]};
  }
`;
